import React from "react";

export const About = () => {
  return (
    <div className="min-h-screen pt-20 bg-white">
      {/* Main Content */}
      <section className="py-32 md:py-40 px-6">
        <div className="max-w-3xl mx-auto text-center">
          {/* Heading */}
          <h1 
            className="text-4xl md:text-5xl mb-20 font-light tracking-wide" 
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}
          >
            The Atelier
          </h1>

          {/* Body Content */}
          <div className="space-y-12">
            <p 
              className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              MIA Atelier creates modern heirlooms for mothers and daughters.
            </p>

            <p 
              className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              Rooted in craftsmanship and shaped by legacy, each piece is designed with intention, elegance, and quiet strength.
            </p>

            <p 
              className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              These are garments made to be worn today and remembered for generations.
            </p>

            {/* Philosophy Section */}
            <div className="pt-12">
              <p 
                className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light mb-8"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                Our philosophy is simple:
              </p>

              <div className="space-y-4">
                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Elegance endures.
                </p>
                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Love is inherited.
                </p>
                <p 
                  className="text-base md:text-lg leading-loose text-[#2C2C2C] font-light"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                >
                  Legacy is worn.
                </p>
              </div>
            </div>

            {/* Location - Whispered */}
            <div className="pt-24">
              <p 
                className="text-sm leading-loose text-[#A39383] font-light"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                Based in Nigeria.
              </p>
              <p 
                className="text-sm leading-loose text-[#A39383] font-light"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                Created for the world.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
